import { useState } from "react";
import "./modal.scss";
import styles from "../campain.module.css";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/prime.css";
import Select from "react-select";
function Filter({ customers, Update }) {
  const animatedComponents = makeAnimated();

  return (
    <>
      <div
        class="modal fade"
        id={`FilterModal`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                فیلتر کمپین
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="edit-user-container">
                <form id="edit-user-form-data" className=" edit-container">
                  <div className="d-flex justify-content-between">
                    <p className="mt-2 w-50 textsmall"> کالا یا محصول کمپین</p>
                    <Select
                      className="inputModal2"
                      // value={customers[index].barchasb}
                      // onChange={changeHandlerDaste}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti={true}

                      // options={optionDasteBandi}
                    />
                  </div>
                  <div className="d-flex justify-content-between">
                    <p className="mt-2 w-50 textsmall"> برچسب کاربران</p>
                    <CreatableSelect
                      className="inputModal2"
                      // value={customers[index].barchasb}
                      // onChange={changeHandlerDaste}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti={true}

                      // options={optionDasteBandi}
                    />
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="mt-2 w-50 textsmall ">عنوان</p>
                    <input className={styles.inputModal} type="text" />
                  </div>
                  <div className="d-flex justify-content-between">
                    <p className="textDateBox textsmall"> زمان شروع </p>
                    <div className="boxDate">
                      <DatePicker
                        className="rmdp-prime"
                        showOtherDays
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="textDateBox textsmall"> زمان پایان </p>
                    <div className="boxDate">
                      <DatePicker
                        className="rmdp-prime"
                        showOtherDays
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="mt-2 w-50 textsmall ">تعداد سرنخ فعال از</p>
                    <input className={styles.inputModal} type="number" />
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="mt-2 w-50 textsmall ">تعداد سرنخ فعال تا</p>
                    <input className={styles.inputModal} type="number" />
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="mt-2 w-50 textsmall "> تعداد پیگیری از</p>
                    <input className={styles.inputModal} type="number" />
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="mt-2 w-50 textsmall ">تعداد پیگیری تا</p>
                    <input className={styles.inputModal} type="number" />
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="mt-2 w-50 textsmall ">
                      تعداد مشتری جذب شده از
                    </p>
                    <input className={styles.inputModal} type="number" />
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="mt-2 w-50 textsmall ">
                      تعداد مشتری جذب شده تا
                    </p>
                    <input className={styles.inputModal} type="number" />
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  Update(customers);
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Filter;
